// **********************************************************
// Close Popup When Escape Key Press
// **********************************************************
const toggleContentModal = (element, toggle) => {
  element.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.content-modal');
    modalElem.forEach((el) => {
      toggleContentModal(el, false);
    });
  }
});

// **********************************************************
// Close Popup When Click On Outside
// **********************************************************

attachEvent('.content-modal__close,.content-modal__overlay', 'click', (ev) => {
  const parentEle = ev.target.closest('.content-modal');
  if (parentEle) {
    toggleContentModal(parentEle, false);
    ev.preventDefault();
  }
});
